import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import CodeOffIcon from '@mui/icons-material/CodeOff';
import CodeIcon from '@mui/icons-material/Code';

import { PopupButton, InlineWidget } from "react-calendly";
import Base13Icon from './../../Color just logo - no background.svg';
import FacebookLogo from './../../facebookLogo.png';
import GoogleAdsLogo from './../../googleAdsLogo.png';
import GoogleAnalyticsLogo from './../../googleAnalyticsLogo.png';
import ShopifyLogo from './../../shopifyLogo.png';
import KlaviyoLogo from './../../klaviyoLogo.png';

import Header from './Header';
import Footer from './Footer';
import ContactFormFree from './ContactFormFree';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      autoWidth: 'false',
    },
  },
  button: {
    margin: theme.spacing(1),
    justifyContent: 'left',
    justify: 'left',
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    // height: 100,
    resizeMode: 'contain'
  },
  paper: {
    maxWidth: 120,
    // height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    // height: 100,
    resizeMode: 'contain'
  },
  shopifyLogo: {
    flex: 1,
    padding: 2,
    maxWidth: 50,
    resizeMode: 'contain'
  },
  facebookLogo: {
    flex: 1,
    padding: 2,
    maxWidth: 65,
    resizeMode: 'contain'
  },
  googleAnalyticsLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 100,
    resizeMode: 'contain'
  },
  googleAdsLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 48,
    resizeMode: 'contain'
  },
  klaviyoLogo: {
    flex: 1,
    padding: 2,
    spacing: 10,
    maxWidth: 70,
    resizeMode: 'contain'
  },
  logoPadding: {
    flex: 1,
    padding: 2,
    maxWidth: 20,
    resizeMode: 'contain'
  },
  text: {
    margin: theme.spacing(1),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardContent: {
    backgroundColor: 'white',
    color: '#0284c7'
  },
}));

export default function FreeVersion() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>
      	<Container maxWidth="lg" component="main" className={classes.heroContent}>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:30}}
        >
          <img className={classes.image} src={Base13Icon}/>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{padding:0}}
        >
        </Box>
        <Grid container spacing={5} alignItems="flex-end">
        <Grid item xs={12} sm={12} md={3} lg={3}><Box/></Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Typography component="h1" style={{padding:20}} variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
            Sign up to our waitlist to access a completely FREE version of FloSQL.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}><Box/></Grid>
        </Grid>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{padding:0}}
          >
          <CreditCardOffIcon style={{color:'#0284c7', width:20, height:20}} fontsize="small"/>
          <Typography variant="p6" style={{ fontFamily: 'Arial', padding:10 }} align="center" color="textSecondary" component="p">
           <Box sx={{ fontWeight: 'bold'}} display='inline' >No credit card required</Box>
          </Typography>
          <CodeIcon style={{color:'#0284c7', width:20, height:20}} fontsize="small"/>
          <Typography variant="p6" style={{ fontFamily: 'Arial', padding:10 }} align="center" color="textSecondary" component="p">
           <Box sx={{ fontWeight: 'bold'}} display='inline' >Work with just SQL</Box>
          </Typography>
        </Box>

          <form style={{ padding:30 }}>
          <Grid container alignItems="flex-end" spacing={2}>
              <Grid xs={2} sm={4} md={4} lg={4} >
                <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:0}}
              >
              </Box>
              </Grid>
              <Grid xs={8} sm={4} md={4} lg={4} >
              <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:0}}
              >
                <ContactFormFree />
              </Box>
              </Grid>
              <Grid xs={2} sm={4} md={4} lg={4} >
                <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:0}}
              >
              </Box>
              </Grid>

          </Grid>
          </form>
      	</Container>
      <Footer/>
    </React.Fragment>
  );
}